import React, { useContext, useEffect, useState } from 'react'
import ColorButton from '../Buttons/ColorButton'
import apptheme from '../theme/default'
import { Box } from '@mui/material'
import '../Settings/styles.css'
import DefButton from '../Buttons/defbutton'
import ReplyIcon from '@mui/icons-material/Reply';
import { getSession } from '../../contexts/auth'
import { useWindowSize } from "@uidotdev/usehooks";
import { CalcWidthSize } from '../Settings'

import { externalComponent } from '../AppRoutes'
import FaturatedServiceOrder from './OrdemServicoFaturada'
import TechnicalAssistance from './AssistenciaTecnica'
import EngineeringIcon from '@mui/icons-material/Engineering'
import EventRepeatIcon from '@mui/icons-material/EventRepeat'

const MenuList = () => {

    const user = getSession()
    const permissions = user?.permissions

    return ({
        'servicos': {
            title: 'Ordem de Serviço Faturadas',
            icon: (<EngineeringIcon />),
            obj: (<FaturatedServiceOrder />),
            permission: (permissions.view_service)
        },
        'assistencia': {
            title: 'Prazo de Assistência Técnica',
            icon: (<EventRepeatIcon />),
            obj: (<TechnicalAssistance />),
            permission: (permissions.view_service)
        },
    })
}

const Relatorios = () => {
    const { isMobile } = useContext(externalComponent)
    const [selectedTab, setSelectedTab] = useState()
    const size = useWindowSize();

    const menulist = MenuList()

    const calcSize = CalcWidthSize(size)

    const itens = Object.entries(menulist).filter(([key, value]) => value.permission)

    useEffect(()=>{
        window.backtobase = () => setSelectedTab()
    }, [])

    return (
        <>
            {!selectedTab ?
                <>
                    <Box className='gridBox' sx={{ gridTemplateColumns: `repeat(${calcSize}, minMax(0, 1fr))` }}>
                        {itens.map(([key, value]) => (
                            <ColorButton
                                onClick={() => setSelectedTab(key)}
                                sx={{ height: '8rem', flex: 1, visibility: !value.obj ? 'hidden' : 'visible' }}
                                fColor={apptheme.primaryColor}
                                sColor={apptheme.tertiaryColor}>
                                <Box className='flexbox'>
                                    {value.icon}
                                    {value.title}
                                </Box>
                            </ColorButton>

                        ))}
                    </Box>
                </>
                :
                <>
                    <Box className={`settings-back-button ${isMobile ? '': 'hidden'}`}>
                        <DefButton
                            onClick={() => setSelectedTab()}
                        >
                            <ReplyIcon />
                        </DefButton>
                    </Box>
                    {MenuList()[selectedTab].obj}
                </>
            }

        </>
    )
}

export default Relatorios